import React, { useContext, useMemo } from 'react';

import { ItemsDisplayMode } from './config';
import type { ItemsDisplayModeEnumType } from './types';

type ContextType = {
  itemsDisplayMode: ItemsDisplayModeEnumType;
};

const defaultValue: ContextType = {
  itemsDisplayMode: ItemsDisplayMode.IconsTitles,
};

export const FloatingMenuContext = React.createContext(defaultValue);
FloatingMenuContext.displayName = 'FloatingMenuContext';

export const useFloatingMenuContext = () => useContext(FloatingMenuContext);

export const FloatingMenuContextProvider: React.FC<{
  itemsDisplayMode: ItemsDisplayModeEnumType;
  children: React.ReactNode;
}> = ({ itemsDisplayMode, children }) => {
  const value = useMemo(() => ({ itemsDisplayMode }), [itemsDisplayMode]);

  return <FloatingMenuContext.Provider value={value}>{children}</FloatingMenuContext.Provider>;
};
